import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import MrfTypes from "./mrfTypes";
import { getMrfTypeList } from "services/redux/MaterialRequistionForm/action";

const mapStateToProps = (state) => ({
  mrfTypeData: state.MaterialRequistionForm.mrfTypeData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getMrfTypeList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MrfTypes);